import { Language } from '../../../enums/const-enums';

export interface RassCardInputTranslations {
  card_number: {
    label: string;
    hint: string;
    format_error: string;
  };
  checkbox: {
    label: string;
  };
}

const nlTranslations: RassCardInputTranslations = {
  card_number: {
    label: 'Pasnummer',
    hint: '4 cijfers van het pasnummer',
    format_error: 'Pasnummer is onjuist',
  },
  checkbox: {
    label: 'Onthouden',
  },
};

const enTranslations: RassCardInputTranslations = {
  card_number: {
    label: 'Card number',
    hint: '4 digits of your card number',
    format_error: 'Card number invalid',
  },
  checkbox: {
    label: 'Remember',
  },
};

export const rassCardInputTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
